import { render, staticRenderFns } from "./DescriptionsReport.vue?vue&type=template&id=1feb224e&scoped=true"
import script from "./DescriptionsReport.vue?vue&type=script&lang=js"
export * from "./DescriptionsReport.vue?vue&type=script&lang=js"
import style0 from "./DescriptionsReport.vue?vue&type=style&index=0&id=1feb224e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb224e",
  null
  
)

export default component.exports